var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("path", {
    d: "m10.811 31.135a16 16 0 0 1-10.106-19.832 16 16 0 0 1 19.494-10.742 16 16 0 0 1 11.368 19.137 16 16 0 0 1-18.759 11.981",
    fill: "#020000",
    fillOpacity: 0.065327,
    style: {
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.059 0 0 1.0927 -.9438 -1.4831)",
    fillOpacity: 0.47236
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 5c-3.8555 0-7 3.1445-7 7 0 2.4102 1.2305 4.5508 3.0938 5.8125-3.5664 1.5312-6.0938 5.0703-6.0938 9.1875h2c0-4.4297 3.5703-8 8-8 4.4297 0 8 3.5703 8 8h2c0-4.1172-2.5273-7.6562-6.0938-9.1875 1.8633-1.2617 3.0938-3.4023 3.0938-5.8125 0-3.8555-3.1445-7-7-7zm0 2c2.7734 0 5 2.2266 5 5 0 2.7734-2.2266 5-5 5-2.7734 0-5-2.2266-5-5 0-2.7734 2.2266-5 5-5z",
    fillOpacity: 0.47236
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericUser);
export default __webpack_public_path__ + "static/media/generic-user.94db3fa2b195c148e279e22baa1c450b.svg";
export { ForwardRef as ReactComponent };